/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryResponse } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetProcessTypeDependencyGraph";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentUseCasesControllerGetProcessTypeDependencyGraph } from "../../clients/document-use-casesService/documentUseCasesControllerGetProcessTypeDependencyGraph";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentUseCasesControllerGetProcessTypeDependencyGraphQueryKey = () => [{
  url: '/api/v1/documents/processings/process-type-graph'
}] as const;
export type DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryKey = ReturnType<typeof documentUseCasesControllerGetProcessTypeDependencyGraphQueryKey>;
export function documentUseCasesControllerGetProcessTypeDependencyGraphQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentUseCasesControllerGetProcessTypeDependencyGraphQueryKey();
  return queryOptions<DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryResponse, ResponseErrorConfig<Error>, DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentUseCasesControllerGetProcessTypeDependencyGraph(config);
    }
  });
}

/**
 * @description Returns the dependency graph of all document process types, showing which types depend on others. Use this to understand execution order and validate reprocessing requests.
 * @summary Get the process type dependency graph
 * {@link /api/v1/documents/processings/process-type-graph}
 */
export function useDocumentUseCasesControllerGetProcessTypeDependencyGraph<TData = DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryResponse, TQueryData = DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryResponse, TQueryKey extends QueryKey = DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryKey>(options: {
  query?: Partial<QueryObserverOptions<DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentUseCasesControllerGetProcessTypeDependencyGraphQueryKey();
  const query = useQuery({
    ...documentUseCasesControllerGetProcessTypeDependencyGraphQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}